export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["继续"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入密码确认"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码确认"])}
}